import React, { ReactElement } from "react";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { ExitToApp } from "@mui/icons-material";
import { useDispatch, useSelector } from "../../store";
import { logout } from "../../slices/authentication";
import theme from "../../theme";
import CompanyLogo from "../base/CompanyLogo";

interface Props {
  handleClose: () => void;
  children?: ReactElement;
}

const ProfileMenuView: React.FC<Props> = (props) => {
  const { handleClose, children } = props;
  const dispatch = useDispatch();

  const { loggedInUser, userCompany } = useSelector(
    (store) => store.authentication
  );

  const menuItems = [
    {
      label: "Logout",
      icon: <ExitToApp />,
      function: () => {
        dispatch(logout());
      },
      authorized: true,
    },
  ];

  return (
    <Box width={250} display="flex" role="presentation" onClick={handleClose}>
      <List sx={{ width: "100%" }}>
        <ListItem disablePadding>
          <ListItemText
            primary={`${loggedInUser?.firstName} ${loggedInUser?.lastName}`}
            slotProps={{
              primary: {
                fontSize: 20,
                color: "primary",
                justifySelf: "center",
              },
            }}
          />
        </ListItem>
        {userCompany && (
          <>
            <Box>
              <ListItem>
                <ListItemIcon sx={{ paddingX: 2 }}>
                  <CompanyLogo company={userCompany} size="50px" />
                </ListItemIcon>
                <ListItemText
                  primary={userCompany?.companyName}
                  slotProps={{
                    primary: {
                      fontSize: 18,
                      fontWeight: "bold",
                      color: "primary",
                    },
                  }}
                />
              </ListItem>
              <Divider sx={{ margin: 1 }} />
            </Box>
          </>
        )}
        {children && (
          <>
            {children}
            <Divider sx={{ margin: 1 }} />
          </>
        )}
        {menuItems
          .filter((x) => !!x.authorized)
          .map((item) => (
            <Box key={item.label}>
              <ListItem disablePadding>
                <ListItemButton
                  onClick={item.function}
                  sx={{
                    "&:hover, &:focus": {
                      "& svg:first-of-type": {
                        transition: "0.5s",
                        transform: "rotate(-180deg)",
                      },
                    },
                  }}
                >
                  <ListItemIcon sx={{ paddingX: 2 }}>
                    <Avatar
                      sx={{
                        backgroundColor: theme.palette.primary.main,
                        width: "35px",
                        height: "35px",
                        color: "#fff",
                      }}
                    >
                      <IconButton color="inherit">{item.icon}</IconButton>
                    </Avatar>
                  </ListItemIcon>
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      fontSize: 16,
                      fontWeight: "light",
                      color: "primary",
                    }}
                  />
                </ListItemButton>
              </ListItem>
            </Box>
          ))}
      </List>
    </Box>
  );
};

export default ProfileMenuView;

// import { Box, Divider } from "@mui/material";
// import React from "react";
// import { Base } from "../base";
// import { useDispatch } from "../../store";
// import { logout } from "../../slices/authentication";

// interface Props {
//   onClose: () => void;
// }

// const DesktopMenu: React.FC<Props> = (props) => {
//   const { onClose } = props;
//   const dispatch = useDispatch();

//   const handleLogout = () => {
//     dispatch(logout());
//     onClose();
//   };

//   return (
//     <Box sx={{ width: 200 }}>
//       <Box sx={{ display: "flex", justifyContent: "center", marginY: "5px" }}>
//         <Base.Text text={`###version###`} center />
//       </Box>
//       <Divider />
//       <Box sx={{ p: "10px" }}>
//         <Base.Button fullWidth text="Logout" onClick={handleLogout} />
//       </Box>
//     </Box>
//   );
// };

// export default DesktopMenu;
